"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultWidth = 575;
var defaultHeight = 400;

var getCenter = function getCenter(outer, inner) {
  var result = (outer - inner) / 2;
  return result > 0 ? Math.floor(result) : 0;
};

var openWindow = exports.openWindow = function openWindow(url, windowId) {
  if (!window) return;

  var windowWidth = window.innerWidth || window.document.documentElement.clientWidth || window.document.body.clientWidth;

  var windowHeight = window.innerHeight || window.document.documentElement.clientHeight || window.document.body.clientHeight;

  var width = defaultWidth;
  var height = defaultHeight;
  var left = getCenter(windowWidth, defaultWidth);
  var top = getCenter(windowHeight, defaultHeight);
  var opts = "status=1,width=" + width + ",height=" + height + ",left=" + left + ",top=" + top;

  var childWindow = window.open(url, windowId, opts);
  childWindow.moveTo(left, top);
};